<template>
    <a-modal
        :visible="visible"
        :title="state.title"
        @ok="ConversionPoint"
        @cancel="handleModalCancel"
        width="60%"
        :destroy-on-close="true"
        :footer="null">
    
        <AForm
            ref="formRef"
            class="myform"
            :model="form"
            :rules="state.rules"
            @finish="handleOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <!-- bulan -->
            <AFormItem
                label="Pilih Bulan"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="bulan"
                has-feedback>
                <AMonthPicker
                    v-model:value="form.bulan"
                    :allow-clear="false"
                    placeholder="Pilih Bulan"
                    :disabled-date="disabledDate"
                    format="MMMM YYYY"
                    @change="fetchTargetDay"
                    :disabled="form.readOnly"
                    style="width:100%;"/>
            </AFormItem>

            <!-- pilih salesman -->
            <AFormItem
                label="Pilih Salesman"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="salesman_id"
                has-feedback>
                <FilterATSalesmanSalesman
                    v-model:value="form.salesman_id"
                    :useram_id="form.useram_id"
                    :disabled="form.readOnly || !form.bulan"
                    :mode="null"
                    style="width:100%;"
                    :join-options="
                        form.salesman_id
                            ? [{ id: item.salesman_id, nopeg: item.salesman_nopeg, name: item.salesman_name }]
                            : []"/>
            </AFormItem>


            <AFormItem
                label="Target Visit"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="target_visit"
                has-feedback>
                <AInput
                    placeholder="number"
                    type="number"
                    :min="0"
                    v-model:value="form.target_visit"
                    :disabled="form.readOnly"/>
            </AFormItem>

            <ARow
                v-if="!form.readOnly"
                class="form-row"
                type="flex"
                justify="end">
                <ACol>
                    <AFormItem>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="form.busy"
                            :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                        }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="state.errors">
            <ASpace>
                <AAlert
                    v-for="(item, index) in state.errors"
                    type="error"
                    :key="index"
                    :message="item"
                    banner
                    closable
                    @close="state.errors = []" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
} from 'vue'
import FilterATSalesmanSalesman from '@/components/filter/FilterATSalesmanSalesman'
import Form from 'vform'
import { Modal, message } from 'ant-design-vue'
import moment from 'moment'
import {
    ROLE_ADMIN_BK,
    hasRoles,
} from '@/helpers'

export default defineComponent({
    components: {
        FilterATSalesmanSalesman,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const form = reactive(new Form({
            id: props.item.id,
            bulan: null,
            salesman_id: [],
            target_visit: null,
        }))

        const formRef = ref();

        const state = reactive({
            title: 'Lihat Data Target Salesman Corsales',
            endpoint: '/api/unknown',
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                bulan: [
                    {
                        required: true,
                        message: 'Bulan tidak boleh kosong!',
                    },
                ],
                salesman_id: [
                    {
                        required: true,
                        message: 'Salesman tidak boleh kosong!',
                    },
                ],
                target_visit: [
                    {
                        required: true,
                        message: 'Target visit tidak boleh kosong!',
                    },
                ],
            },
            errors: [],
            errors: [],
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const disabledDate = current => {
            return current && current < moment().startOf('month')
        }

        const handleOk = async () => {

            // validation form
            await formRef.value.validate()
                .catch(() => {});

            if (!form.id) {
                form.post(state.endpoint)
                    .then(({ data }) => {
                        message.success('Berhasil menyimpan')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(({ response: { data, status } }) => {
                        if (data) {
                            state.errors = data.errors
                        }
                    })
            } else {
                form.put(`${state.endpoint}/${form.id}`)
                    .then(({ data }) => {
                        message.success('Berhasil memperbarui')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(({ response: { data, status } }) => {
                        if (data) {
                            state.errors = data.errors
                        }
                    })
            }

        }

        // handle func vue
        onMounted(() => {
            if (!form.id) {
                form.reset()
            } else {
                form.bulan = props.item.bulan
                form.salesman_id = props.item.salesman_id
                form.target_visit = props.item.target_visit
                form.readOnly = props.item.readOnly
            }

            if (!props.item.readOnly) {
                state.title = `${!form.id ? 'Tambah' : 'Edit'} Data Target Salesman Corsales`
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
            disabledDate,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
